export type REQUESTS_SUMMARY_LOAD = 'REQUESTS_SUMMARY/LOAD';
export const REQUESTS_SUMMARY_LOAD: REQUESTS_SUMMARY_LOAD = 'REQUESTS_SUMMARY/LOAD';

export type REQUESTS_CATEGORIES_LOAD = 'REQUESTS_CATEGORIES/LOAD';
export const REQUESTS_CATEGORIES_LOAD: REQUESTS_CATEGORIES_LOAD = 'REQUESTS_CATEGORIES/LOAD';

export type REQUESTS_CATEGORIES_COUNT = 'REQUESTS_CATEGORIES_COUNT/LOAD';
export const REQUESTS_CATEGORIES_COUNT: REQUESTS_CATEGORIES_COUNT = 'REQUESTS_CATEGORIES_COUNT/LOAD';

export type REQUEST_CATEGORY_ITEMS_LOAD = 'REQUEST_CATEGORY_ITEMS/LOAD';
export const REQUEST_CATEGORY_ITEMS_LOAD: REQUEST_CATEGORY_ITEMS_LOAD = 'REQUEST_CATEGORY_ITEMS/LOAD';

export type REQUEST_CATEGORY_WITH_ITEMS_LOAD = 'REQUEST_CATEGORY_WITH_ITEMS/LOAD';
export const REQUEST_CATEGORY_WITH_ITEMS_LOAD: REQUEST_CATEGORY_WITH_ITEMS_LOAD = 'REQUEST_CATEGORY_WITH_ITEMS/LOAD';

export type REQUEST_CATEGORY_ITEM_QUESTIONS_LOAD = 'REQUEST_CATEGORY_ITEM_QUESTIONS/LOAD';
export const REQUEST_CATEGORY_ITEM_QUESTIONS_LOAD: REQUEST_CATEGORY_ITEM_QUESTIONS_LOAD
    = 'REQUEST_CATEGORY_ITEM_QUESTIONS/LOAD';

export type REQUEST_CATEGORY_WITH_ITEM_QUESTIONS_LOAD = 'REQUEST_CATEGORY_WITH_ITEM_QUESTIONS/LOAD';
export const REQUEST_CATEGORY_WITH_ITEM_QUESTIONS_LOAD: REQUEST_CATEGORY_WITH_ITEM_QUESTIONS_LOAD
    = 'REQUEST_CATEGORY_WITH_ITEM_QUESTIONS/LOAD';

export type REQUEST_CATEGORY_WITH_DEAC_QUESTIONS_LOAD = 'REQUEST_CATEGORY_WITH_DEAC_QUESTIONS/LOAD';
export const REQUEST_CATEGORY_WITH_DEAC_QUESTIONS_LOAD: REQUEST_CATEGORY_WITH_DEAC_QUESTIONS_LOAD
    = 'REQUEST_CATEGORY_WITH_DEAC_QUESTIONS/LOAD';

export type REQUESTS_CREATE = 'REQUESTS/CREATE';
export const REQUESTS_CREATE: REQUESTS_CREATE = 'REQUESTS/CREATE';

export type REQUEST_DETAILS_LOAD = 'REQUEST_DETAILS_LOAD';
export const REQUEST_DETAILS_LOAD: REQUEST_DETAILS_LOAD = 'REQUEST_DETAILS_LOAD';

export type REQUEST_ACTIVITY_DETAILS_LOAD = 'REQUEST_ACTIVITY_DETAILS_LOAD';
export const REQUEST_ACTIVITY_DETAILS_LOAD: REQUEST_ACTIVITY_DETAILS_LOAD = 'REQUEST_ACTIVITY_DETAILS_LOAD';

export type REQUESTS_OPEN_LOAD = 'REQUESTS_OPEN/LOAD';
export const REQUESTS_OPEN_LOAD: REQUESTS_OPEN_LOAD = 'REQUESTS_OPEN/LOAD';

export type REQUESTS_CLOSED_LOAD = 'REQUESTS_CLOSED/LOAD';
export const REQUESTS_CLOSED_LOAD: REQUESTS_CLOSED_LOAD = 'REQUESTS_CLOSED/LOAD';

export type MAXIM_REQUESTS_OPEN_LOAD = 'MAXIM_REQUESTS_OPEN/LOAD';
export const MAXIM_REQUESTS_OPEN_LOAD: MAXIM_REQUESTS_OPEN_LOAD = 'MAXIM_REQUESTS_OPEN/LOAD';

export type MAXIM_REQUESTS_CLOSED_LOAD = 'MAXIM_REQUESTS_CLOSED/LOAD';
export const MAXIM_REQUESTS_CLOSED_LOAD: MAXIM_REQUESTS_CLOSED_LOAD = 'MAXIM_REQUESTS_CLOSED/LOAD';

export type REQUESTS_FILE_UPLOAD = 'REQUESTS_FILE_UPLOAD';
export const REQUESTS_FILE_UPLOAD: REQUESTS_FILE_UPLOAD = 'REQUESTS_FILE_UPLOAD';

export type REQUEST_DOMESTIC_ACTIVITIES_LOAD = 'REQUEST_DOMESTIC_ACTIVITIES_LOAD';
export const REQUEST_DOMESTIC_ACTIVITIES_LOAD: REQUEST_DOMESTIC_ACTIVITIES_LOAD = 'REQUEST_DOMESTIC_ACTIVITIES_LOAD';

export type REQUESTS_ADD_COMMENT = 'REQUESTS/COMMENT';
export const REQUESTS_ADD_COMMENT: REQUESTS_ADD_COMMENT = 'REQUESTS/COMMENT';

export type REQUESTS_CUSTOMER_REFERENCE = 'PATCH_REQUESTS';
export const REQUESTS_CUSTOMER_REFERENCE: REQUESTS_CUSTOMER_REFERENCE = 'PATCH_REQUESTS';

export type UPDATE_SYNC_ERRORS = '@@redux-form/UPDATE_SYNC_ERRORS';
export const UPDATE_SYNC_ERRORS: UPDATE_SYNC_ERRORS = '@@redux-form/UPDATE_SYNC_ERRORS';

export type PREVIOUS_SYNC_ERRORS_LOAD = 'PREVIOUS_SYNC_ERRORS_LOAD';
export const PREVIOUS_SYNC_ERRORS_LOAD: PREVIOUS_SYNC_ERRORS_LOAD = 'PREVIOUS_SYNC_ERRORS_LOAD';

export type REQUESTS_DEVICES_LOAD = 'REQUESTS_DEVICES/LOAD';
export const REQUESTS_DEVICES_LOAD: REQUESTS_DEVICES_LOAD = 'REQUESTS_DEVICES/LOAD';

export type REQUESTS_DEVICES_SUMMARY_LOAD = 'REQUESTS_DEVICES_SUMMARY/LOAD';
export const REQUESTS_DEVICES_SUMMARY_LOAD: REQUESTS_DEVICES_SUMMARY_LOAD = 'REQUESTS_DEVICES_SUMMARY/LOAD';

export type REQUESTS_DEVICES_CHARGEABLE_LOAD = 'REQUESTS_DEVICES_CHARGEABLE/LOAD';
export const REQUESTS_DEVICES_CHARGEABLE_LOAD: REQUESTS_DEVICES_CHARGEABLE_LOAD = 'REQUESTS_DEVICES_CHARGEABLE/LOAD';

export type ENROLL_HISTORY_DATA_LOAD = 'ENROLL_HISTORY_DATA/LOAD';
export const ENROLL_HISTORY_DATA_LOAD: ENROLL_HISTORY_DATA_LOAD = 'ENROLL_HISTORY_DATA/LOAD';

export type MDM_SEARCH_LOCATIONS = 'MDM/SEARCH_LOCATIONS';
export const MDM_SEARCH_LOCATIONS: MDM_SEARCH_LOCATIONS = 'MDM/SEARCH_LOCATIONS';

export type MDM_UPDATE_SEARCH_LOCATIONS = 'MDM/UPDATE_SEARCH_LOCATIONS';
export const MDM_UPDATE_SEARCH_LOCATIONS: MDM_UPDATE_SEARCH_LOCATIONS =
    'MDM/UPDATE_SEARCH_LOCATIONS';

export type MDM_SORT_LOCATIONS_SUCCESS = 'MDM/SORT_LOCATIONS_SUCCESS';
export const MDM_SORT_LOCATIONS_SUCCESS: MDM_SORT_LOCATIONS_SUCCESS =
    'MDM/SORT_LOCATIONS_SUCCESS';

export type ONLINE_ORDERING_SORT_LOCATIONS = 'ONLINE_ORDERING/SORT_LOCATIONS';
export const ONLINE_ORDERING_SORT_LOCATIONS: ONLINE_ORDERING_SORT_LOCATIONS = 'ONLINE_ORDERING/SORT_LOCATIONS';

export type REQUESTS_DEVICE_DETAIL_LOAD = 'REQUESTS_DEVICE_DETAIL/LOAD';
export const REQUESTS_DEVICE_DETAIL_LOAD: REQUESTS_DEVICE_DETAIL_LOAD = 'REQUESTS_DEVICE_DETAIL/LOAD';

export type REQUESTS_TENANCY_DETAILS_LOAD = 'REQUESTS_TENANCY_DETAILS/LOAD';
export const REQUESTS_TENANCY_DETAILS_LOAD: REQUESTS_TENANCY_DETAILS_LOAD = 'REQUESTS_TENANCY_DETAILS/LOAD';

export type REQUESTS_USER_DETAIL_LOAD = 'REQUESTS_USER_DETAIL/LOAD';
export const REQUESTS_USER_DETAIL_LOAD: REQUESTS_USER_DETAIL_LOAD = 'REQUESTS_USER_DETAIL/LOAD';

export type MDM_LOAD_TOPTENAPPS = 'LOAD_TOP_TEN_APPS_LIST_MDM/LOAD_TOPTENAPPS';
export const MDM_LOAD_TOPTENAPPS: MDM_LOAD_TOPTENAPPS =
    'LOAD_TOP_TEN_APPS_LIST_MDM/LOAD_TOPTENAPPS';

export type UPDATE_COVID19_REQUEST_FLAG = 'UPDATE_COVID19_REQUEST_FLAG';
export const UPDATE_COVID19_REQUEST_FLAG: UPDATE_COVID19_REQUEST_FLAG = 'UPDATE_COVID19_REQUEST_FLAG';

export type REQUEST_MOBILE_SERVICES = 'REQUEST_MOBILE_SERVICES/LOAD';
export const REQUEST_MOBILE_SERVICES: REQUEST_MOBILE_SERVICES = 'REQUEST_MOBILE_SERVICES/LOAD';

export type REQUEST_STRATEGIC_DEVICE_DETAILS = 'REQUEST_STRATEGIC_DEVICE_DETAILS/LOAD';
export const REQUEST_STRATEGIC_DEVICE_DETAILS:
REQUEST_STRATEGIC_DEVICE_DETAILS = 'REQUEST_STRATEGIC_DEVICE_DETAILS/LOAD';

export type REQUEST_STRATEGIC_SIM_CONFIG_INFO = 'REQUEST_STRATEGIC_SERVICE_INFO/LOAD';
export const REQUEST_STRATEGIC_SIM_CONFIG_INFO:
REQUEST_STRATEGIC_SIM_CONFIG_INFO = 'REQUEST_STRATEGIC_SERVICE_INFO/LOAD';

export type REQUEST_FEATURE_FLAGS = 'REQUEST_FEATURE_FLAGS/LOAD';
export const REQUEST_FEATURE_FLAGS: REQUEST_FEATURE_FLAGS = 'REQUEST_FEATURE_FLAGS/LOAD';

export type FEATURE_NETWORK_CHANGE_SERVICE_LIST = 'FEATURE_NETWORK_CHANGE_SERVICE_LIST/LOAD';
export const FEATURE_NETWORK_CHANGE_SERVICE_LIST: FEATURE_NETWORK_CHANGE_SERVICE_LIST =
    'FEATURE_NETWORK_CHANGE_SERVICE_LIST/LOAD';

export type SERVICE_REQUEST_FETCH_USER_PROFILE = 'SERVICE_REQUEST_FETCH_USER_PROFILE/LOAD';
export const SERVICE_REQUEST_FETCH_USER_PROFILE: SERVICE_REQUEST_FETCH_USER_PROFILE
    = 'SERVICE_REQUEST_FETCH_USER_PROFILE/LOAD';

export type FEATURE_NETWORK_CHANGE_REQUEST_TYPE_DETAILS = 'FEATURE_NETWORK_CHANGE_REQUEST_TYPE_DETAILS/LOAD';
export const FEATURE_NETWORK_CHANGE_REQUEST_TYPE_DETAILS: FEATURE_NETWORK_CHANGE_REQUEST_TYPE_DETAILS
    = 'FEATURE_NETWORK_CHANGE_REQUEST_TYPE_DETAILS/LOAD';

export type NBN_SERVICE_LIST = 'NBN_SERVICE_LIST/LOAD';
export const NBN_SERVICE_LIST: NBN_SERVICE_LIST = 'NBN_SERVICE_LIST/LOAD';

export type REQUEST_PRODUCT_FAMILIES = 'REQUEST_PRODUCT_FAMILIES/LOAD';
export const REQUEST_PRODUCT_FAMILIES: REQUEST_PRODUCT_FAMILIES = 'REQUEST_PRODUCT_FAMILIES/LOAD';

export type FEATURE_NETWORK_CHANGE_PRODUCT_CATALOGUE = 'FEATURE_NETWORK_CHANGE_PRODUCT_CATALOGUE/LOAD';
export const FEATURE_NETWORK_CHANGE_PRODUCT_CATALOGUE: FEATURE_NETWORK_CHANGE_PRODUCT_CATALOGUE =
    'FEATURE_NETWORK_CHANGE_PRODUCT_CATALOGUE/LOAD';

export type NBN_TESTS_CREATE = 'NBN_TESTS/CREATE';
export const NBN_TESTS_CREATE: NBN_TESTS_CREATE = 'NBN_TESTS/CREATE';

export type REQUESTS_ALL_LOAD = 'REQUESTS_ALL/LOAD';
export const REQUESTS_ALL_LOAD: REQUESTS_ALL_LOAD = 'REQUESTS_ALL/LOAD';

export type INTERNET_PRODUCT_LOAD = 'INTERNET_PRODUCT_LOAD_ALL/LOAD';
export const INTERNET_PRODUCT_LOAD: INTERNET_PRODUCT_LOAD = 'INTERNET_PRODUCT_LOAD_ALL/LOAD';

export type MAXIM_REQUESTS_ALL_LOAD = 'MAXIM_REQUESTS_ALL/LOAD';
export const MAXIM_REQUESTS_ALL_LOAD: MAXIM_REQUESTS_ALL_LOAD = 'MAXIM_REQUESTS_ALL/LOAD';

export type FEATURE_NETWORK_CHANGE_REQUESTS = 'FEATURE_NETWORK_CHANGE_REQUESTS/LOAD';
export const FEATURE_NETWORK_CHANGE_REQUESTS: FEATURE_NETWORK_CHANGE_REQUESTS = 'FEATURE_NETWORK_CHANGE_REQUESTS/LOAD';

export type NBN_TESTS_POLL = 'NBN_TESTS/POLL';
export const NBN_TESTS_POLL: NBN_TESTS_POLL = 'NBN_TESTS/POLL';

export type NBN_UPDATE_TEST_RESULT = 'NBN_TESTS/UPDATE_TEST_RESULT';
export const NBN_UPDATE_TEST_RESULT: NBN_UPDATE_TEST_RESULT = 'NBN_TESTS/UPDATE_TEST_RESULT';

export type NBN_UPDATE_RESULT = 'NBN_TESTS/UPDATE_RESULT';
export const NBN_UPDATE_RESULT: NBN_UPDATE_RESULT = 'NBN_TESTS/UPDATE_RESULT';

export type NBN_UPDATE_DIAGNOSTIC_RESULT = 'NBN_TESTS/UPDATE_DIAGNOSTIC_RESULT';
export const NBN_UPDATE_DIAGNOSTIC_RESULT: NBN_UPDATE_DIAGNOSTIC_RESULT = 'NBN_TESTS/UPDATE_DIAGNOSTIC_RESULT';

export type NBN_UPDATE_DIAGNOSTIC_ERROR = 'NBN_TESTS/UPDATE_DIAGNOSTIC_ERROR';
export const NBN_UPDATE_DIAGNOSTIC_ERROR: NBN_UPDATE_DIAGNOSTIC_ERROR = 'NBN_TESTS/UPDATE_DIAGNOSTIC_ERROR';

export type NBN_ADD_TOAST = 'NBN_TESTS/ADD_TOAST';
export const NBN_ADD_TOAST: NBN_ADD_TOAST = 'NBN_TESTS/ADD_TOAST';

export type NBN_DELETE_TOAST = 'NBN_TESTS/DELETE_TOAST';
export const NBN_DELETE_TOAST: NBN_DELETE_TOAST = 'NBN_TESTS/DELETE_TOAST';

export type NBN_ADD_RESULT_TOAST = 'NBN_TESTS/ADD_RESULT_TOAST';
export const NBN_ADD_RESULT_TOAST: NBN_ADD_RESULT_TOAST = 'NBN_TESTS/ADD_RESULT_TOAST';

export type NBN_DELETE_RESULT_TOAST = 'NBN_TESTS/DELETE_RESULT_TOAST';
export const NBN_DELETE_RESULT_TOAST: NBN_DELETE_RESULT_TOAST = 'NBN_TESTS/DELETE_RESULT_TOAST';

export type NBN_DISMISS_RESULT_TOAST = 'NBN_TESTS/DISMISS_RESULT_TOAST';
export const NBN_DISMISS_RESULT_TOAST: NBN_DISMISS_RESULT_TOAST = 'NBN_TESTS/DISMISS_RESULT_TOAST';

export type NBN_ADD_ERROR_TOAST = 'NBN_TESTS/ADD_ERROR_TOAST';
export const NBN_ADD_ERROR_TOAST: NBN_ADD_ERROR_TOAST = 'NBN_TESTS/ADD_ERROR_TOAST';

export type NBN_DELETE_ERROR_TOAST = 'NBN_TESTS/DELETE_ERROR_TOAST';
export const NBN_DELETE_ERROR_TOAST: NBN_DELETE_ERROR_TOAST = 'NBN_TESTS/DELETE_ERROR_TOAST';

export type VALIDATE_SIM_LOAD = 'VALIDATE_SIM/LOAD';
export const VALIDATE_SIM_LOAD: VALIDATE_SIM_LOAD = 'VALIDATE_SIM/LOAD'

export type NBN_UPDATE_SERVICE_LIST = 'NBN_TESTS/UPDATE_SERVICE_LIST';
export const NBN_UPDATE_SERVICE_LIST: NBN_UPDATE_SERVICE_LIST = 'NBN_TESTS/UPDATE_SERVICE_LIST';

export type NBN_UPDATE_SERVICE_LIST_PAGINATION = 'NBN_TESTS/UPDATE_SERVICE_LIST_PAGINATION';
export const NBN_UPDATE_SERVICE_LIST_PAGINATION: NBN_UPDATE_SERVICE_LIST_PAGINATION
    = 'NBN_TESTS/UPDATE_SERVICE_LIST_PAGINATION';
export type FEATURE_NETWORK_CHANGE_FNN_VALIDATION = 'FEATURE_NETWORK_CHANGE_FNN_VALIDATION/LOAD';
export const FEATURE_NETWORK_CHANGE_FNN_VALIDATION: FEATURE_NETWORK_CHANGE_FNN_VALIDATION =
    'FEATURE_NETWORK_CHANGE_FNN_VALIDATION/LOAD';

export type REQUESTS_LOAD_COMPANY = 'REQUESTS/LOAD_COMPANY';
export const REQUESTS_LOAD_COMPANY: REQUESTS_LOAD_COMPANY = 'REQUESTS/LOAD_COMPANY';

export type NBN_HISTORY_DETAIL = 'NBN_TESTS/HISTORY_DETAIL';
export const NBN_HISTORY_DETAIL: NBN_HISTORY_DETAIL = 'NBN_TESTS/HISTORY_DETAIL';

export type LIST_OF_ATTACHMENTS = 'LIST_OF_ATTACHMENTS/LOAD';
export const LIST_OF_ATTACHMENTS: LIST_OF_ATTACHMENTS = 'LIST_OF_ATTACHMENTS/LOAD';
export type DELETE_FILE_ATTACHMENTS = 'DELETE_FILE_ATTACHMENTS';
export const DELETE_FILE_ATTACHMENTS: DELETE_FILE_ATTACHMENTS = 'DELETE_FILE_ATTACHMENTS';
export type DOWNLOAD_FILE_ATTACHMENT = 'DOWNLOAD_FILE_ATTACHMENT';
export const DOWNLOAD_FILE_ATTACHMENT: DOWNLOAD_FILE_ATTACHMENT = 'DOWNLOAD_FILE_ATTACHMENT';

export type SRM_SESSION_STORAGE_UPDATE = 'SRM_SESSION_STORAGE/UPDATE';
export const SRM_SESSION_STORAGE_UPDATE: SRM_SESSION_STORAGE_UPDATE = 'SRM_SESSION_STORAGE/UPDATE';
export type REQUESTS_LOAD_SM_SERVICE_ID = 'REQUESTS/LOAD_SM_SERVICE_ID';
export const REQUESTS_LOAD_SM_SERVICE_ID: REQUESTS_LOAD_SM_SERVICE_ID = 'REQUESTS/LOAD_SM_SERVICE_ID';

export type MAXIM_REQUEST_DETAILS = 'MAXIM_REQUEST_DETAILS';
export const MAXIM_REQUEST_DETAILS: MAXIM_REQUEST_DETAILS = 'MAXIM_REQUEST_DETAILS';

export type LOAD_MAXIM_ACTIVITIES = 'MAXIM_ACTIVITIES/LOAD';
export const LOAD_MAXIM_ACTIVITIES: LOAD_MAXIM_ACTIVITIES = 'MAXIM_ACTIVITIES/LOAD';

export type REQUESTS_CUSTOMER_CONTACT_LOAD = 'REQUESTS_CUSTOMER_CONTACT_LOAD/LOAD';
export const REQUESTS_CUSTOMER_CONTACT_LOAD:
REQUESTS_CUSTOMER_CONTACT_LOAD = 'REQUESTS_CUSTOMER_CONTACT_LOAD/LOAD';
export type DELIVERY_ADDRESS_AUTO_SEARCH_LIST = 'DELIVERY_ADDRESS_AUTO_SEARCH_LIST/LOAD';
export const DELIVERY_ADDRESS_AUTO_SEARCH_LIST:
DELIVERY_ADDRESS_AUTO_SEARCH_LIST = 'DELIVERY_ADDRESS_AUTO_SEARCH_LIST/LOAD';

export type ADDRESS_SIMPLIFIED_LIST = 'ADDRESS_SIMPLIFIED_LIST/LOAD';
export const ADDRESS_SIMPLIFIED_LIST:
ADDRESS_SIMPLIFIED_LIST = 'ADDRESS_SIMPLIFIED_LIST/LOAD';

export type ADVANCED_ADDRESS_LIST = 'ADVANCED_ADDRESS_LIST/LOAD';
export const ADVANCED_ADDRESS_LIST:
ADVANCED_ADDRESS_LIST = 'ADVANCED_ADDRESS_LIST/LOAD';

export type APN_LIST = 'APN_LIST/LOAD';
export const APN_LIST:
APN_LIST = 'APN_LIST/LOAD';

export type CIDN_ASSOCIATED_SERVICE = 'CIDN_ASSOCIATED_SERVICE_LIST/LOAD';
export const CIDN_ASSOCIATED_SERVICE:
CIDN_ASSOCIATED_SERVICE = 'CIDN_ASSOCIATED_SERVICE_LIST/LOAD';

export type REQUEST_NIT_SERVICE_FLAG = 'REQUEST_NIT_SERVICE_FLAG';
export const REQUEST_NIT_SERVICE_FLAG: REQUEST_NIT_SERVICE_FLAG = 'REQUEST_NIT_SERVICE_FLAG';
export type SET_TRACKING_ACTIVE_TAB = 'SET_TRACKING_ACTIVE_TAB';
export const SET_TRACKING_ACTIVE_TAB:
SET_TRACKING_ACTIVE_TAB = 'SET_TRACKING_ACTIVE_TAB';

export type UPDATE_COMPANY_ID = 'UPDATE_COMPANY_ID';
export const UPDATE_COMPANY_ID: UPDATE_COMPANY_ID = 'UPDATE_COMPANY_ID';
export type MOBILE_SERVICES_LIST = 'MOBILE_SERVICES_LIST/LOAD';
export const MOBILE_SERVICES_LIST: MOBILE_SERVICES_LIST = 'MOBILE_SERVICES_LIST/LOAD';
export type TON_SUBSCRIPTION_DETAILS_LOAD = 'TON_SUBSCRIPTION_DETAILS/LOAD';
export const TON_SUBSCRIPTION_DETAILS_LOAD: TON_SUBSCRIPTION_DETAILS_LOAD = 'TON_SUBSCRIPTION_DETAILS/LOAD';

export type MOBILE_SERVICES_DETAIL_STRATEGIC = 'MOBILE_SERVICES_DETAIL_STRATEGIC/LOAD';
export const MOBILE_SERVICES_DETAIL_STRATEGIC:
MOBILE_SERVICES_DETAIL_STRATEGIC = 'MOBILE_SERVICES_DETAIL_STRATEGIC/LOAD';

export type MOBILE_SERVICE_ETC_LEGACY = 'MOBILE_SERVICE_ETC_LEGACY/LOAD';
export const MOBILE_SERVICE_ETC_LEGACY:
MOBILE_SERVICE_ETC_LEGACY = 'MOBILE_SERVICE_ETC_LEGACY/LOAD';
export type EARLY_TERMINATION_CHARGES_LOAD = 'EARLY_TERMINATION_CHARGES/LOAD';
export const EARLY_TERMINATION_CHARGES_LOAD: EARLY_TERMINATION_CHARGES_LOAD = 'EARLY_TERMINATION_CHARGES/LOAD';

export type ADAPTIVE_MOBILITY_PLAN_LOAD = 'ADAPTIVE_MOBILITY_PLAN/LOAD';
export const ADAPTIVE_MOBILITY_PLAN_LOAD: ADAPTIVE_MOBILITY_PLAN_LOAD = 'ADAPTIVE_MOBILITY_PLAN/LOAD';

export type ADD_ONS_DETAILS_LOAD = 'ADD_ONS_DETAILS_LOAD';
export const ADD_ONS_DETAILS_LOAD: ADD_ONS_DETAILS_LOAD = 'ADD_ONS_DETAILS_LOAD';

export type IR_MONTH_PASS_ADD_ONS_DETAILS_LOAD = 'IR_MONTH_PASS_ADD_ONS_DETAILS_LOAD';
export const IR_MONTH_PASS_ADD_ONS_DETAILS_LOAD: IR_MONTH_PASS_ADD_ONS_DETAILS_LOAD =
    'IR_MONTH_PASS_ADD_ONS_DETAILS_LOAD';

export type ACCELERATOR_ADD_ONS_DETAILS_LOAD = 'ACCELERATOR_ADD_ONS_DETAILS_LOAD';
export const ACCELERATOR_ADD_ONS_DETAILS_LOAD: ACCELERATOR_ADD_ONS_DETAILS_LOAD = 'ACCELERATOR_ADD_ONS_DETAILS_LOAD';

export type USER_MANAGEMENT_GET_USER_DYNAMIC = 'USER_MANAGEMENT_GET_USER_DYNAMIC';
export const USER_MANAGEMENT_GET_USER_DYNAMIC: USER_MANAGEMENT_GET_USER_DYNAMIC = 'USER_MANAGEMENT_GET_USER_DYNAMIC';

export type SERVICE_PERFORMANCE_LOAD_SERVICES_SUMMARY = 'SERVICE_PERFORMANCE/LOAD_SERVICES_SUMMARY';
export const SERVICE_PERFORMANCE_LOAD_SERVICES_SUMMARY: SERVICE_PERFORMANCE_LOAD_SERVICES_SUMMARY = 'SERVICE_PERFORMANCE/LOAD_SERVICES_SUMMARY';

export type MANAGE_DIRECTORY_LISTING_LOAD = 'MANAGE_DIRECTORY_LISTING_LOAD';
export const MANAGE_DIRECTORY_LISTING_LOAD: MANAGE_DIRECTORY_LISTING_LOAD = 'MANAGE_DIRECTORY_LISTING_LOAD';

export type INTERNET_PRODUCT_DETAILS_LOAD = 'INTERNET_PRODUCT_DETAILS_LOAD';
export const INTERNET_PRODUCT_DETAILS_LOAD: INTERNET_PRODUCT_DETAILS_LOAD = 'INTERNET_PRODUCT_DETAILS_LOAD';

export type INTERNET_PRODUCT_DNS_DETAILS_LOAD = 'INTERNET_PRODUCT_DNS_DETAILS_LOAD';
export const INTERNET_PRODUCT_DNS_DETAILS_LOAD: INTERNET_PRODUCT_DNS_DETAILS_LOAD = 'INTERNET_PRODUCT_DNS_DETAILS_LOAD';

export type INTERNET_PRODUCT_DNS_LIST_LOAD = 'INTERNET_PRODUCT_DNS_LIST_LOAD';
export const INTERNET_PRODUCT_DNS_LIST_LOAD: INTERNET_PRODUCT_DNS_LIST_LOAD = 'INTERNET_PRODUCT_DNS_LIST_LOAD';
